// Services
import { type BlocTexteType } from '@/services/blocksSchema';

// Components
import Markdown from '@/components/atoms/Markdown/Markdown';

// Style
import styles from './BlocTexte.module.css';

interface BlocTexteProps {
  text?: BlocTexteType['text'];
  bgColor?: BlocTexteType['bgColor'];
}

function BlocTexte({
  text = null,
  bgColor = 'blanc',
}: BlocTexteProps) {
  
  return (
    <div className={bgColor === 'blanc' ? styles['bg-white'] : styles['bg-grey']}>
      <div className={styles.container}>
        <div className={styles.content}>
          {
            text ? (
              <Markdown
                text={text}
              />
            ) : null
          }
        </div>
      </div>
    </div>
  );
}

export default BlocTexte;
